<template>
  <div :class="$store.state.screenMode === 'dark' ? 'dark' : ''">
    <button
      class="btn btn-dark mt-5"
      v-if="!userIsLoggedIn"
      @click="googleSignin"
      id="signInBtn"
    >
      Log in
    </button>
    <div id="userProfilePicture" v-if="userIsLoggedIn" class="d-flex flex-row">
      <div class="mr-3 mt-auto mb-auto d-flex">
        <img :src="profilePic" />
        <p id="userName">{{ userName }}</p>
      </div>
      <button
        class="btn btn-dark m-auto"
        id="signOutBtn"
        style="height: 50px"
        @click="handleSignout"
      >
        Log out
      </button>
    </div>
  </div>
</template>


<script>
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

export default {
  name: "LoginPartial",
  computed: {
    userName() {
      let username = localStorage.getItem("userName");
      return this.$store.state.name ? this.$store.state.name : username;
    },
    profilePic() {
      let profilepic = localStorage.getItem("profilePic");
      return this.$store.state.profilepic
        ? this.$store.state.profilepic
        : profilepic;
    },
    email() {
      let email = localStorage.getItem("email");
      return this.$store.state.email ? this.$store.state.email : email;
    },
    userIsLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
  },
  data() {
    return {};
  },
  methods: {
    async googleSignin() {
      const provider = new GoogleAuthProvider();
      const auth = getAuth();
      signInWithPopup(auth, provider)
        .then(async (result) => {
          this.$store.commit("setUserData", { user: result.user });
          // This gives you a Google Access Token. You can use it to access the Google API.
          const credential = GoogleAuthProvider.credentialFromResult(result);
          const token = credential.accessToken;
          // The signed-in user info.
          const user = result.user;
          // ...

          this.$store.dispatch("retrieveUserFavoriteTools");

          this.$store
            .dispatch(
              "retrieveUserSelectedBackground",
              localStorage.getItem("email")
            )
            .then(() => {
              if (this.$store.state.loggedInFirebaseUser) {
                let obj = {
                  imageFile:
                    this.$store.state.loggedInFirebaseUser[0].attributes
                      .BackgroundImageStart,
                };
                this.$store.state.backgroundStartScreen = obj;

                // this.selectedBackground = obj;
                this.$emit("click");
              }
            });
          this.$store
            .dispatch(
              "retrieveUserSelectedScreenMode",
              localStorage.getItem("email")
            )
            .then(() => {
              if (this.$store.state.isLoggedIn) {
                if (this.$store.state.screenMode === "dark") {
                  let app = document.getElementById("app");
                  app.style.background = "#131313";
                  document.body.style.background = "#131313";
                  this.$store.commit("setScreenMode", "dark");
                  this.active = true;
                } else {
                  document.body.style.background = "white";
                  app.style.background = "white";
                  this.$store.commit("setScreenMode", undefined);
                  localStorage.setItem("ScreenMode", "light");
                  this.$store.dispatch("setScreenModeForUserInStrapi", "light");
                  this.active = false;
                }
              } else if (localStorage.getItem("ScreenMode") === "dark") {
                let app = document.getElementById("app");
                app.style.background = "#131313";
                document.body.style.background = "#131313";
                this.$store.commit("setScreenMode", "dark");
                this.active = true;
                this.active = true;
              } else {
                document.body.style.background = "white";
                app.style.background = "white";
                this.$store.commit("setScreenMode", undefined);
                localStorage.setItem("ScreenMode", "light");
                this.$store.dispatch("setScreenModeForUserInStrapi", "light");
                this.active = false;
              }
            });
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          // The AuthCredential type that was used.
          const credential = GoogleAuthProvider.credentialFromError(error);
          // ...
        });
    },
  },
  emits: ["click"],
};
</script>
<script setup>
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const router = useRouter();

const isLoggedIn = ref(false);
let auth;
onMounted(() => {
  auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user !== null) {
      isLoggedIn.value = !!user;
      store.state.isLoggedIn = isLoggedIn.value;
    }
  });
});

const handleSignout = () => {
  signOut(auth).then(() => {
    store.commit("removeUserData");
    router.push(store.state.routing.startPage);
  });
};
</script>
<style scoped>
.dark #userName {
  color: white;
}

#signOutBtn,
#signInBtn {
  height: 48px;
  width: 88px;
  border-radius: 15px;
  border: 1px solid transparent;
  transition: width 0.4s, background-color 0.4s;
}

#signInBtn {
  background-color: var(--yungo-primary-button);
  margin-top: auto !important;
  margin-bottom: auto !important;
}

#signOutBtn {
  background-color: var(--yungo-primary-btn-click);
}

#userProfilePicture img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-size: contain;
}

#userName {
  height: 23px;
  width: auto;
  color: #ffffff;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 23px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 14px;
}

#signInBtn:hover {
  background-color: var(--yungo-primary-btn-hover);
}

/* #signOutBtn:hover,
#signInBtn:hover {
  width: 120px;
} */

#signInBtn:active {
  background-color: var(--yungo-primary-btn-click);
}

#signInBtn:disabled {
  background-color: var(--yungo-primary-btn-disabled);
}

@media only screen and (max-width: 992px) {
  #userProfilePicture {
    justify-content: space-between;
    width: 100%;
  }
  #userProfilePicture button {
    margin: 0 !important;
  }

  #login {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  footer {
    flex-wrap: wrap;
    padding: 0;
    padding-left: 25px;
    padding-right: 25px;
  }

  #userProfilePicture {
    flex-wrap: wrap !important;
    flex-direction: column !important;
  }

  #userProfilePicture div {
    justify-content: center;
  }
  #userProfilePicture div,
  #userProfilePicture button {
    width: 100% !important;
    margin-bottom: 10px !important;
  }

  footer div:first-child {
    width: 100%;
  }

  /* #userProfilePicture {
    flex-wrap: inherit !important;
    flex-direction: inherit !important;
  } */

  button#signOutBtn {
    width: 100%;
  }
}
</style>